import React from 'react';

interface ErrorFallbackProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

/**
 * ErrorFallback component
 * Displays a user-friendly error message with optional retry button
 * Use this for API errors (400, 404, 500, network errors)
 */
const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  message = 'Error fetching data',
  onRetry,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div className="w-16 h-16 mb-4 text-error-500 dark:text-error-400">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h3 className="heading-3 mb-2 text-center">Oops!</h3>
      <p className="body-base text-text-secondary text-center mb-4">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-primary">
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorFallback;
